var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.55556,
    fill: "#767676",
    stroke: "white",
    strokeWidth: 0.888889
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44361 5.44492C5.59238 5.29615 5.83359 5.29615 5.98236 5.44492L7.9987 7.46126L10.015 5.44492C10.1638 5.29615 10.405 5.29615 10.5538 5.44492C10.7026 5.59369 10.7026 5.8349 10.5538 5.98367L8.53745 8.00001L10.5538 10.0164C10.7026 10.1651 10.7026 10.4063 10.5538 10.5551C10.405 10.7039 10.1638 10.7039 10.015 10.5551L7.9987 8.53876L5.98236 10.5551C5.83359 10.7039 5.59238 10.7039 5.44361 10.5551C5.29484 10.4063 5.29484 10.1651 5.44361 10.0164L7.45995 8.00001L5.44361 5.98367C5.29484 5.8349 5.29484 5.59369 5.44361 5.44492Z",
    fill: "#F7F9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.ed90aa6880cce5702c7e0a77833f642f.svg";
export { ForwardRef as ReactComponent };